














































































































































































































































































































































































































































































































































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  GetReportPdfData,
  PreviewPdf,
  UpdateReportPdf,
  GetReportPdfStandardList,
  GetClassInfo,
  GetPdfClassList,
  GetSqlMaintainProps,
} from "@/api/reportSetting";
import { GetFormSetting } from "@/api/assessForm";
import { GetSqlTemps } from "@/api/systemBasic";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;
  modalTitle: string = "";
  saveLoading: boolean = false;
  pdfModel: any = {};
  pdfData: any = {};
  treeData: any = []; // 数组件的数据源
  pdfFormData: any = {}; //PDF属性设置
  tableFormData: any = {}; //table属性设置
  cellFormData: any = {}; //单元格属性设置
  currentNode: any = {}; //当前点击的节点
  currentNodeType = ""; //当前节点类型
  standardList: any = []; //打印纸规格下拉框
  pdfClassList: any = []; //用于绑定实体类的列表
  pdfUrl = ""; //pdf预览地址
  sqlMaintainList: any = []; //sql报表集合
  buttonProps = {
    type: "default",
    size: "small",
  };

  created() {
    this.initSelect();
    if (this.data.mode == "add") {
      this.modalTitle = "添加报表";
      this.pdfModel = {};
    } else {
      this.modalTitle = "修改报表";
      this.pdfModel = this.data.data;
      this.getData();
      this.previewPdf();
    }
  }

  async initSelect() {
    let res = await GetReportPdfStandardList();
    this.standardList = res.objects;
    res = await GetPdfClassList();
    this.pdfClassList = res.objects;
    res = await GetSqlTemps({});
    this.sqlMaintainList = res.objects;
  }

  async getData() {
    if (!this.pdfModel) {
      return;
    }
    let res = await GetReportPdfData({ reportId: this.pdfModel.id });
    if (res.objects) {
      this.pdfData = res.objects;
      this.initTreeData();
    }
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  initTreeData() {
    if (!this.pdfData.isShowPage) {
      this.pdfData.isShowPage = false;
    }
    this.treeData = [
      {
        id: this.pdfData.id,
        label: this.pdfData.reportName,
        data: this.pdfData,
        nodeType: "pdf",
        children: [],
      },
    ];
    if (this.pdfData.tableList) {
      this.pdfData.tableList.forEach((table) => {
        if (!table.isLockedWidth) {
          table.isLockedWidth = false;
        }
        if (!table.isList) {
          table.isList = false;
        }
        if(!table.isNoShowListHeard){
          table.isNoShowListHeard = false;
        }
        if (!table.isHeader) {
          table.isHeader = false;
        }
        if (!table.isFooter) {
          table.isFooter = false;
        }
        if (!table.isShowHeaderAfterPaged) {
          table.isShowHeaderAfterPaged = false;
        }
        if (!table.isAssessForm) {
          table.isAssessForm = false;
        }
        if (!table.isContinuity) {
          table.isContinuity = false;
        }
        if (!table.isTrends) {
          table.isTrends = false;
        }
        if (!table.isSqlMaintain) {
          table.isSqlMaintain = false;
        }
        if (!table.setWatermark) {
          table.setWatermark = false;
        }
        let pdfChild = {
          id: table.id,
          label: table.tableName,
          data: table,
          nodeType: "table",
          children: [],
        };
        if (table.cellList) {
          table.cellList.forEach((cell) => {
            if (!cell.isBold) {
              cell.isBold = false;
            }
            if (!cell.isImage) {
              cell.isImage = false;
            }
            if (!cell.isDate) {
              cell.isDate = false;
            }
            if (!cell.isOnlyHeader) {
              cell.isOnlyHeader = false;
            }
            if (!cell.isQrCode) {
              cell.isQrCode = false;
            }
            if (!cell.isGroupSign) {
              cell.isGroupSign = false;
            }
            if (!cell.isShow) {
              cell.isShow = false;
            }
            if (!cell.isHideLabel) {
              cell.isHideLabel = false;
            }
            if (!cell.isRichText) {
              cell.isRichText = false;
            }
            if (!cell.isBarCode) {
              cell.isBarCode = false;
            }
            let tableChild = {
              id: cell.id,
              label: cell.propName,
              data: cell,
              nodeType: "cell",
            };
            pdfChild.children.push(tableChild);
          });
        }
        this.treeData[0].children.push(pdfChild);
      });
    }
  }

  append(data) {
    let newChild: any = {
      id: new Date().getTime(),
      data: {},
      nodeType: "",
      children: [],
    };
    if (data.nodeType == "pdf") {
      newChild.nodeType = "table";
      newChild.label = "表名称";
      newChild.data.tableName = "表名称";
      newChild.data.isLockedWidth = true;
      newChild.data.paddingTop = 10;
    } else if (data.nodeType == "table") {
      newChild.nodeType = "cell";
      newChild.label = "属性名";
      newChild.data.propName = "属性名";
      newChild.data.horizontalAlignment = "ALIGN_LEFT";
      newChild.data.verticalAlignment = "ALIGN_TOP";
      newChild.data.fontSize = 11;
      newChild.data.isShow = true;
    }
    if (!data.children) {
      this.$set(data, "children", []);
    }
    data.children.push(newChild);
  }

  remove(node, data) {
    const parent = node.parent;
    const children = parent.data.children || parent.data;
    const index = children.findIndex((d) => d.id === data.id);
    children.splice(index, 1);
  }

  //点击节点时触发
  handleNodeClick(data) {
    console.log(data);
    this.currentNode = data;
    this.currentNodeType = data.nodeType;
    switch (data.nodeType) {
      case "pdf":
        this.pdfFormData = data.data;
        if (!this.pdfFormData.bindingClassName) {
          this.pdfFormData.bindingClassName = "";
        }
        break;
      case "table":
        this.tableFormData = data.data;
        break;
      case "cell":
        this.cellFormData = data.data;
        break;
    }
  }

  @Watch("pdfFormData", { immediate: true, deep: true })
  handlePdfChanged() {
    if (this.treeData && this.treeData.length > 0) {
      this.treeData[0].label = this.pdfFormData.reportName;
    }
  }

  @Watch("tableFormData", { immediate: true, deep: true })
  handleTableChanged() {
    if (this.treeData && this.treeData.length > 0) {
      if (this.treeData[0].children) {
        this.treeData[0].children.forEach((table) => {
          table.label = table.data.tableName;
        });
      }
    }
  }

  @Watch("cellFormData", { immediate: true, deep: true })
  handleCellChanged() {
    if (this.treeData && this.treeData.length > 0) {
      if (this.treeData[0].children) {
        this.treeData[0].children.forEach((table) => {
          table.children.forEach((cell) => {
            cell.label = cell.data.propName;
          });
        });
      }
    }
  }

  async previewPdf() {
    if (this.data) {
      let res = await PreviewPdf(this.pdfModel.reportName);
      if (res) {
        // this.pdfUrl = res;
        this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(res)}`;
        console.warn(this.pdfUrl);
      }
    }
  }

  async save() {
    console.log(this.treeData);
    if (this.treeData && this.treeData.length > 0) {
      let payload = {
        ...this.treeData[0].data,
        tableList: [],
      };
      this.treeData[0].children.forEach((table) => {
        let t = {
          ...table.data,
          cellList: [],
        };
        table.children.forEach((cell) => {
          t.cellList.push({
            ...cell.data,
          });
        });
        payload.tableList.push(t);
      });

      await UpdateReportPdf(payload);
    }
  }

  async showClassInfo() {
    if (this.pdfFormData.isAssessForm) {
      //评估单
      if (!this.pdfFormData.assessFormName) {
        this.$Message.error("请输入表单名称");
        return;
      }
      let res = await GetFormSetting({
        formName: this.pdfFormData.assessFormName,
      });
      if (res.data && res.data.list) {
        let propList = [];
        res.data.list.forEach((item) => {
          if (item.model && item.name) {
            propList.push({
              propName: item.model,
              propDesc: item.name,
            });
          }
        });
        this.showNotice(propList);
      }
    } else {
      if (this.pdfFormData.isSqlMaintain) {
        if (!this.pdfFormData.sqlMaintainName) {
          this.$Message.error("请输入SQL报表名称");
          return;
        }
        let res = await GetSqlMaintainProps({
          sqlMaintainName: this.pdfFormData.sqlMaintainName,
        });
        if (res.objects) {
          this.showNotice(res.objects);
        }
      } else {
        if (!this.pdfFormData.bindingClassName) {
          this.$Message.error("请输入类名");
          return;
        }
        let res = await GetClassInfo({
          className: this.pdfFormData.bindingClassName,
        });
        if (res.objects) {
          this.showNotice(res.objects);
        }
      }
    }
  }

  showNotice(propList) {
    this.$Notice.destroy();
    this.$Notice.open({
      title: "字段参考",
      duration: 0,
      render: (h: any) => {
        let divList = [];
        propList.forEach((prop) => {
          let divLine = [
            h(
              "div",
              {
                style: { float: "left" },
              },
              `${prop.propName}：`
            ),
            h(
              "div",
              {
                style: { float: "left" },
              },
              prop.propDesc
            ),
          ];
          if (prop.subPropertyList && prop.subPropertyList.length > 0) {
            prop.subPropertyList.forEach((subProp) => {
              divLine.push(
                h(
                  "div",
                  {
                    style: {
                      overflow: "hidden",
                      clear: "both",
                      marginLeft: "20px",
                      fontSize: "10px",
                      lineHeight: "16px",
                      fontStyle: "italic",
                      color: "#26baff",
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          float: "left",
                        },
                      },
                      `★ ${subProp.propName}：`
                    ),
                    h(
                      "div",
                      {
                        style: {
                          float: "left",
                        },
                      },
                      subProp.propDesc
                    ),
                  ]
                )
              );
            });
          }
          let div = h(
            "div",
            {
              style: {
                overflow: "hidden",
                fontSize: "12px",
                lineHeight: "16px",
                color: "#12cb77",
              },
            },
            divLine
          );
          divList.push(div);
        });
        return h(
          "div",
          {
            style: {
              overflowY: "auto",
              height: "500px",
            },
          },
          divList
        );
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/reportSetting/edit.vue